import { RATIO_OF_MOLLAR_MASSES } from './constants'

export default function calculateProcessEmissionsFromBakeAnodeConsumption(
  netPrebakeAnodeComsumption: number,
  sulphurContent: number,
  ashContent: number
): number {
  const emissions = netPrebakeAnodeComsumption * ((100 - sulphurContent - ashContent) / 100) * RATIO_OF_MOLLAR_MASSES

  return emissions
}
